import { render } from "./HeroiconsOutlineBadgeCheck.vue?vue&type=template&id=679f87a2"
const script = {}

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineBadgeCheck.vue"]])

export default __exports__